import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconTools from '@/icons/Tools.svg';
import { ArticleDefectWithRelations } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { createBEMClasses } from '@/utils/classname';

import { getEditedFields } from './getEditedFields';

import './DefectsCard.css';

const { element } = createBEMClasses('defect-card');

export const DefectToBeRepairedBadge = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  const { errors } = useArticleContext();

  const missingActions = errors.defects?.defects?.find(
    (def) => def.id === defect?.id
  )?.missingActions;

  return (
    <Badge
      hasBorder
      color="neutral"
      borderRadius="soft"
      size="large"
      className={element('badge', {
        edited: getEditedFields({ defect, previousDefect }).isToBeRepairedEdited,
        error: missingActions,
      })}
    >
      <IconTools />
      {(defect ?? previousDefect!).toBeRepaired ? (
        <Trans id="defect-card.to-be-repaired.yes">To be repaired: Yes</Trans>
      ) : (
        <Trans id="defect-card.to-be-repaired.no">To be repaired: No</Trans>
      )}
    </Badge>
  );
};
